var _ellipse, _ellipse2, _ellipse3, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLargeSnowBoardPage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59,
    height: 97,
    viewBox: "0 0 59 97",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.8011,
    cy: 43.2186,
    rx: 6.83239,
    ry: 7.01208,
    fill: "#DDEBF6"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.65,
    cx: 48.4662,
    cy: 21.9828,
    rx: 6.83239,
    ry: 7.01208,
    fill: "#DDEBF6"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.3,
    cx: 25.6459,
    cy: 7.95739,
    rx: 6.83239,
    ry: 7.01208,
    fill: "#DDEBF6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.537109 96.5234C10.5341 86.4473 36.2224 65.5407 58.9996 62.5234V84.5234C58.9996 84.5525 58.9995 84.5815 58.9993 84.6105V91.6103C58.9993 94.3238 56.818 96.5236 54.1274 96.5236H40.9384L40.9385 96.5234H0.537109Z",
    fill: "url(#paint0_linear_4691_18997)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4691_18997",
    x1: 29.7683,
    y1: 62.5234,
    x2: 70.0322,
    y2: 114.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDEBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargeSnowBoardPage);
export default __webpack_public_path__ + "static/media/largeSnow-board-page.a4bc05767cace0a1281cdf73fbfe5f5a.svg";
export { ForwardRef as ReactComponent };